import Landing from "_+_Portal/_-_Autocheckin/pages/Landing/Landing";
import Home from "../pages/Home/Home";
import Login from "../pages/Login/Login";
import LoginToken from "../pages/Login/LoginToken";
import PaginaNoEncontrada from "../pages/PaginaNoEncontrada/PaginaNoEncontrada";
import ConsultaMedica from "_+_Portal/pages/ConsultaMedica/ConsultaMedica";
import Estudios from "_+_Portal/pages/Estudios/Estudios";
import TurnosDisponibles from "_+_Portal/pages/TurnosDisponibles/TurnosDisponibles";
import TurnosDisponiblesKin from "_+_Portal/pages/TurnosDisponibles/TurnosDisponiblesKin";
import ProximosTurnos from "_+_Portal/pages/ProximosTurnos/ProximosTurnos";
import Laboratorio from "_+_Portal/pages/Laboratorio/Laboratorio";

const routes = [
  {
    id: 1,
    path: "/login",
    component: Login,
    title: "Login",
    needsAuth: false,
  },
  {
    id: 2,
    path: "/landing",
    component: Landing,
    title: "Landing DIM",
    needsAuth: false,
  },
  {
    id: 3,
    path: "/notfound",
    component: PaginaNoEncontrada,
    title: "Página no encontrada",
    needsAuth: false,
  },
  {
    id: 4,
    path: "/home",
    component: Home,
    title: "Home",
    needsAuth: true,
  },
  {
    id: 5,
    path: "/auth/activacion",
    component: LoginToken,
    title: "Activación",
    needsAuth: false,
  },
  {
    id: 6,
    path: "/",
    component: Login,
    title: "Login",
    needsAuth: false,
  },
  {
    id: 7,
    path: "/consultamedica",
    component: ConsultaMedica,
    title: "Consulta Médica",
    needsAuth: true,
  },
  {
    id: 8,
    path: "/estudios",
    component: Estudios,
    title: "Estudios",
    needsAuth: true,
  },
  {
    id: 9,
    path: "/laboratorio",
    component: Laboratorio,
    title: "Laboratorio",
    needsAuth: true,
  },
  {
    id: 10,
    path: "/turnosDisponibles",
    component: TurnosDisponibles,
    title: "Turnos Disponibles",
    needsAuth: true,
  },
  {
    id: 11,
    path: "/turnosDisponiblesKinesiologia",
    component: TurnosDisponiblesKin,
    title: "Turnos Disponibles Kinesiología",
    needsAuth: true,
  },
  {
    id: 12,
    path: "/proximosTurnos",
    component: ProximosTurnos,
    title: "Próximos Turnos",
    needsAuth: true,
  },
];

export default routes;
